import { Node } from "../node.js";
/**
 * @public
 */
export class Text extends Node {
    static of(owner, name) {
        return new Text(owner, name);
    }
    _name;
    constructor(owner, name) {
        super(owner, [], "text");
        this._name = name;
    }
    get name() {
        return this._name;
    }
    clone() {
        return new Text(this._node, this._name);
    }
    isIgnored() {
        return false;
    }
    toJSON() {
        const result = {
            ...super.toJSON(),
            name: this._name.map((name) => name.value).getOr(null),
        };
        delete result.children;
        return result;
    }
    toString() {
        return `text "${this._name.map((name) => `${name}`).getOr("")}"`;
    }
}
//# sourceMappingURL=text.js.map